import styled from '@emotion/styled'
import { FunctionComponent, PropsWithChildren } from 'react'
import { Colors } from '~/assets/style/colors'
import Button from '~/components/Button'
import { useGlobalFlyout } from '~/components/layout/GlobalFlyout'
import { PageContent } from '~/components/PageContent'
import { TabProp, Tabs } from '~/components/Tabs'
import { WithClassName } from '~/types/utils'
import { AdmRefreshHelpFlyout } from './AdmRefreshHelpFlyout'

const ScopeDetailHeader = styled.div`
  background-color: ${Colors.Ghost};
  position: sticky;
  top: 0;
  margin-bottom: 20px;
`

export const RefreshWrapper = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: column;
`

type PureAdmRefreshPageProps = WithClassName & {
  onTabClick: (tab: TabProp) => unknown
  tabs: TabProp[]
  breadcrumbs?: React.ReactNode
}
const UnstyledPureAdmRefreshPage: FunctionComponent<PropsWithChildren<PureAdmRefreshPageProps>> = ({ className, breadcrumbs, onTabClick, tabs, children }) => {
  const flyout = useGlobalFlyout()

  return (
    <PageContent
      className={className}
      breadcrumbs={breadcrumbs}
      headerActions={
        <Button
          variant={'tertiary'}
          iconName={'help'}
          onClick={() => flyout.open(AdmRefreshHelpFlyout, { color: Colors.Petrol, closeTrackingLabel: 'adm-refresh-rules-help-close' })}
          trackingLabel={'adm-refresh-rules-help'}
        >
          Help
        </Button>
      }
    >
      <ScopeDetailHeader>
        <Tabs tabs={tabs} onClick={onTabClick} />
      </ScopeDetailHeader>
      {children}
    </PageContent>
  )
}

export const PureAdmRefreshPage = styled(UnstyledPureAdmRefreshPage)``
